import AlertCardProps from './types';
import S from './AlertsCardStyles';

function AlertsCard({ data }: { data: AlertCardProps }): JSX.Element {
  return (
    <S.Wrapper $color={data.color || ''}>
      <div className="title">{data.title}</div>
      <div className="label">{data.name}</div>
    </S.Wrapper>
  );
}

export default AlertsCard;
